exports.countryDefinition = {
  country: 'Panama',
  code: 'PA',
  schema: {
    company: { label: 'Company' },
    address: { label: 'Street Address' },
    address2: { label: 'Street Address 2' },
    city: { label: 'Town' },
    stateCode: { label: 'Province' }
  },
  viewFormat: [['company'], ['address'], ['address2'], ['city'], ['stateCode']],
  formFormat: [['company'], ['address'], ['address2'], ['city'], ['stateCode']],
  requiredFormFields: [
    { field: 'address' },
    { field: 'city' },
    { field: 'stateCode' }
  ]
};
